import Dishonored from './Dishonored';

export default Dishonored;
